var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#BFBFBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.917 4.293c.384 0 .721.075 1.01.225.29.15.535.356.733.62.199.263.348.57.45.918.1.348.15.722.15 1.123v.415c0 .42-.037.825-.112 1.216a4.055 4.055 0 01-.366 1.079 3.012 3.012 0 01-.659.869c-.27.247-.602.44-.996.58-.39.138-.85.206-1.377.206h-.107v-.972h.097c.45 0 .824-.058 1.123-.175.303-.121.544-.287.723-.499.179-.211.308-.46.386-.747a3.35 3.35 0 00.106-.645l-.009.01a2.082 2.082 0 01-.63.47 1.731 1.731 0 01-.776.175c-.338 0-.638-.063-.898-.19a1.885 1.885 0 01-.645-.528 2.325 2.325 0 01-.38-.761 3.172 3.172 0 01.029-1.866c.104-.3.255-.563.454-.79.198-.232.44-.41.722-.538.287-.13.61-.195.972-.195zm-.005.937c-.179 0-.34.041-.483.123-.14.078-.26.187-.357.327a1.609 1.609 0 00-.22.483 2.257 2.257 0 00-.073.586c0 .195.023.384.069.566.048.18.12.339.215.479.094.14.213.25.356.332a1 1 0 00.503.122c.182 0 .35-.034.503-.102a1.31 1.31 0 00.4-.289c.112-.117.2-.25.264-.395v-.469c0-.29-.031-.543-.093-.762a1.574 1.574 0 00-.254-.551 1.08 1.08 0 00-.376-.337.948.948 0 00-.454-.113z",
    fill: "#000"
  })));
}
SvgPokerSeats9.displayName = 'PokerSeats9';
export default SvgPokerSeats9;